import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError, isAxiosError } from 'api';
import { formatErrorMessage } from 'utils/format-error-message';
import {
  CreateUserDTO,
  UserApiService,
  VolunteerUserDTO
} from 'features/users/api/user-api.service';
import i18n from 'locales/i18n';

import { userQueryKeys } from './query-keys';


const { createUser, createVolunteer, updateStatus, saveEventWithAgent } = UserApiService();

export const useCreateUser = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: CreateUserDTO) => {
      const data: any = await createUser(payload);

      if (
        data?.responseStatus === 0 ||
        data?.responseStatus === '0' ||
        data?.ResponseStatus === 0 ||
        data?.ResponseStatus === '0'
      ) {
        throw new Error(
          data?.responseMessage ||
          data?.ResponseMessage ||
          'Failed to create user',
        );
      }

      return data;
    },
    {
      onError: (error: any) => {
        const rawMessage = isAxiosError(error)
          ? handleError(error)
          : error?.message || handleError(error);

        message.error(formatErrorMessage(rawMessage));
      },
      onSuccess: (user) => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });
        message.success(
          i18n.t('adminUsers.formStatus.userCreated', {
            fullName: `${user?.first_name || ''} ${user?.last_name || ''}`.trim(),
            role: user?.role || '',
          }),
        );
      },
    },
  );
};


export const useCreateVolunteerUser = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: VolunteerUserDTO) => {
      return createVolunteer(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });

        message.success(i18n.t('volunteer.add_volunteer_msg')
          // i18n.t('adminUsers.formStatus.userCreated', {
          //   fullName: `${user.first_name} ${user.last_name}`,
          //   role: user.role,
          // }),
        );
      },
    },
  );
};

export const useUpdateVolunteerUser = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: VolunteerUserDTO) => {
      return createVolunteer(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });

        message.success(i18n.t('volunteer.update_volunteer_msg')
          // i18n.t('adminUsers.formStatus.userCreated', {
          //   fullName: `${user.first_name} ${user.last_name}`,
          //   role: user.role,
          // }),
        );
      },
    },
  );
};

export const useUpdateStatus = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: any) => {
      return updateStatus(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });

        message.success(i18n.t('volunteer.update_volunteer_msg')
          // i18n.t('adminUsers.formStatus.userCreated', {
          //   fullName: `${user.first_name} ${user.last_name}`,
          //   role: user.role,
          // }),
        );
      },
    },
  );
};

// type responseMessage = {
//   ResponseStatus: number;
//   ResponseMessage: string;
// }
// type mappEventRequest = {
//   agent_id: number,
//   event_id: number,
//   event_name: string

// }

export const useEventWithAgent = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: any) => {
      return saveEventWithAgent(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (user) => {

        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });
        const response: any = user;
        //'i18n.t('volunteer.update_volunteer_msg')'
        message.success(`${response.ResponseMessage} `
          // i18n.t('adminUsers.formStatus.userCreated', {
          //   fullName: `${user.first_name} ${user.last_name}`,
          //   role: user.role,
          // }),
        );
      },
    },
  );
};





